import styled from 'styled-components'

export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`

const MDStyles = styled.div`
  padding: 112px 0 0px;
  padding-top: 112px;
  font-family: charter, system-ui, sans-serif;
  h1 {
    color: var(--baseFullContrast);
    font-size: 30px;
    line-height: 50.4px;
    display: none;
    @media(min-width: 768px) {
      margin-top: 80px;
      font-size: 48px;
      line-height: 56px;
    }
  }
  #title {
    display: block;
  }
  h2 {
    font-size: 22px;
    line-height: 28px;
    margin-bottom: 8px;
    @media(min-width: 768px) {
      font-size: 30px;
      line-height: 50px;
    }
  }
  h3 {
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 4px;
    @media(min-width: 768px) {
      font-size: 24px;
      line-height: 34px;
    }
  }
  p {
    font-size: 18px;
    line-height: 30px;
    color: var(--textOpaque);
    margin-bottom: 32px;
    @media(min-width: 768px) {
      font-size: 21px;
      line-height: 34px;
    }
  }
  img{
    margin: 1em 0;
    width: 100%;
  }
  ul, ol {
    list-style: none;
    padding-left: 16px;
  }
  ol {
    counter-reset: item;
    li {
      counter-increment: item;
      &::before{
        top: 8px;
        content: counter(item);
        font-size: 13px;
        width: 18px;
        height: 18px;
        box-sizing: border-box;
        text-align: center;
        line-height: 19px;
        left: -28px;
        padding-left: 1px;
        color: white;
      }
    }
  }
  li{
    margin-top: 1rem;
    margin: 8px 0 24px;
    font-size: 18px;
    line-height: 30px;
    position: relative;
    color: var(--textOpaque);
    &::before{
      position: absolute;
      width: 8px;
      height: 8px;
      top: 12px;
      bottom: 0px;
      left: -16px;
      content: '';
      display: block;
      background-color: var(--textOpaque);
      border-radius: 50%;
    }
    @media(min-width: 768px) {
      font-size: 21px;
      line-height: 34px;
    }
  }
  p a {
    color: var(--white);
    font-weight: 500;
    text-decoration: underline;
  }
  img {
    width: 100%;
  }
  h3, h4{
    margin-bottom: 4px;
  }
  blockquote {
    padding: 0 0 0 24px;
    font-style: italic;
    border-left: 4px solid var(--baseNeutral);
    margin: 48px 0;
    p {
      color: var(--baseNeutral);
      margin: 0;
      font-size: 21px;
      line-height: 34px;
    }
    li::before{
      border-radius: 0%;
      top: 15px;
      height: 4px;
    }
  }
  table {
    width: auto;
    margin: 2rem auto;
    font-size: 1.2rem;
    color: var(--textOpaque);
    table-layout: fixed;

    th, td {
      padding: 20px;
    }
  }
  code {
    span {
      /* color: #13dcf2; */
      /* color: #13dcf2; */
    }
    .token.unit,
    .token.module {
      color: #ff0071;
    }
    .attr-equals {
      color: #ff0071!important;
    }
    .token.color {
      color: #13dcf2;
    }
    .token.nil {
      color: #b67fff!important;
    }
    .token.control-flow {
      color: #F92672!important;
    }
    .token.property-access {
      color: white;
    }
    .token.interpolation-punctuation {
      color: #389edb!important;
    }
    .token.method-variable.function-variable {
      color: #94e400;
    }
    .token.console {
      color: white!important;
    }
    .token.module {
      color: #ff0071!important;
    }
    .token.imports {
      color: white;
    }
    .token.hexcode.color {
      color: #b67fff;
    }
    .token.parameter {
      color: #FD971F;
      font-style: italic;
    }
  }
  thead {
    background-color: var(--basePrimary);
  }
  /* Why I did this in the pass??? Where's the bug? */
  /* pre { */
    /* padding-bottom: 0!important; */
  /* } */
  hr {
    display: block;
    margin: 48px 0;
    height: 8px;
    background: no-repeat center url(/images/blog/divider-dark.png);
    border: none;
  }
  @media (min-width: 1024px) {
    padding: 0px;
  }
`

export default MDStyles
